import * as React from 'react';
import {RouteComponentProps} from 'react-router';
import {EmailSendResponse, ErrorResponse, Returnal, ReturnalDocumentType, TransportDto} from '../api/dtos/dtos';
import {IdPageUrlParams} from '../paths';
import furoApi from '../api/FuroApi';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import {setAppHeaderSubtitle} from "../app/AppHeader";
import locales from "../locales";
import {ErrorAlert} from "../common/ErrorAlert";
import {idFromPathParams} from "../utils/router-utils";
import RentalDetailsAlert from "../checklist/send/RentalDetailsAlert";
import SendDocumentForm from "./SendDocumentForm";
import {showConfirm} from "../utils/dialogs";
import {showEmailSendResultModal} from "../common/EmailSendResultModal";

interface State {
  returnal?: Returnal;
  hasTransport?: boolean;
  error?: ErrorResponse;
}

class SendReturnalDocumentsPage extends React.Component<RouteComponentProps<IdPageUrlParams>, State> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  constructor(props: RouteComponentProps<{}>) {
    super(props);
    this.state = {
      hasTransport: false,
    };
  }

  public componentDidMount() {
    this.loadReturnal();
    this.loadReturnalTransport();
  }

  public render() {
    const {error, returnal, hasTransport} = this.state;

    const documentTypes: ReturnalDocumentType[] = [ReturnalDocumentType.RETURNAL_REPORT];
    if (hasTransport) {
      documentTypes.push(ReturnalDocumentType.TRANSPORT_LETTER);
    }

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        {returnal &&
            <RentalDetailsAlert
                rental={returnal}
                rentalTitle={locales.rental}
            />
        }
        {returnal &&
            <SendDocumentForm
                clientId={returnal.client!.id!}
                documentTypes={documentTypes}
                onFormCancel={this.onFormCancel}
                onFormSubmit={this.onFormSubmit}
            />
        }

        <ErrorAlert style={{marginTop: '16px'}} error={error}/>
      </>
    );
  }

  private onFormCancel = () => {
    this.props.history.goBack();
  };

  private onFormSubmit = (documentTypes: ReturnalDocumentType[], contactIds: number[]) => {
    showConfirm(locales.document_send_confirm, () => this.sendReturnalDocuments(documentTypes, contactIds));
  };


  private sendReturnalDocuments = (documentTypes: ReturnalDocumentType[], recipientContactIds: number[]) => {
    const rentalID = idFromPathParams(this.props);
    const promise = furoApi.document.sendReturnalDocuments(rentalID, {recipientContactIds, documentTypes})
      .then(this.onSendResponse)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  }

  private onSendResponse = (response: EmailSendResponse) => {
    showEmailSendResultModal({
      title: locales.email_send_result_document,
      response,
      onSuccess: this.pop
    });
  };

  private pop = () => {
    this.props.history.goBack();
  }

  private loadReturnal = () => {
    const returnalID = idFromPathParams(this.props);
    const promise = furoApi.returns.get(returnalID)
      .then(this.onReturnalLoaded)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onReturnalLoaded = (response: Returnal) => {
    this.setState({returnal: response});
    setAppHeaderSubtitle(this.props, locales.document_send_subtitle);
  };

  private loadReturnalTransport = () => {
    const rentalID = idFromPathParams(this.props);
    const promise = furoApi.returns.getTransport(rentalID)
      .then(this.onLoadTransport)
      .catch(this.onApiError)
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onLoadTransport = (response: TransportDto | null) => {
    this.setState({
      hasTransport: response !== null,
      error: undefined,
    });
    setAppHeaderSubtitle(this.props, locales.document_send_subtitle);
  };


  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  }
}

export default SendReturnalDocumentsPage;




// WEBPACK FOOTER //
// ./src/document-sendout/SendReturnalDocumentsPage.tsx